<template>
  <SummarySectionGroup
    v-for="(section, secIndex) in sections"
    :key="section.id"
    :section="section"
    :sectionIndex="secIndex"
    :answers="answers"
    :hovering="hovering"
    @navigate="emit('navigate', $event)"
    @update:hovering="emit('update:hovering', $event)" />
</template>

<script setup lang="ts">
import SummarySectionGroup from "@/features/blueprint/components/summary/SummarySectionGroup.vue";
import { QuestionSchema } from "@/features/blueprint/schema/questions/QuestionSchema";
import { Answers } from "@/features/blueprint/schema/answers/Answers";

defineProps<{
  sections: QuestionSchema[];
  answers: Answers;
  hovering: number | null;
}>();

const emit = defineEmits<{
  (e: "navigate", index: number): void;
  (e: "update:hovering", hovering: number | null): void;
}>();
</script>
